import styled from 'styled-components';

export const InvestmentDocumentCardStyles = styled.div`
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 0.25rem;
	padding: 0.5rem;
	transition: background-color 0.2s ease;
	background: none;
	min-width: 0;
	overflow: hidden;

	&:hover {
		background-color: ${({ theme }) => theme.v3.colors.gray[0]};
	}

	.icon-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 2.5rem;
		height: 2.5rem;
		background: ${({ theme }) => theme.v3.colors.gray[2]};
		border-radius: 0.25rem;
		flex-shrink: 0;
	}

	.settings-btn {
		display: flex;
		align-items: center;
		border-radius: 0.25rem;
		padding: 0.25rem;
		transition: background 0.2s ease;
		cursor: pointer;

		&:hover {
			background: ${({ theme }) => theme.v3.colors.gray[2]};
		}
	}

	.doc-name {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: block;
		max-width: 100%;
	}
`;
